<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1 py-2" v-if="Object.keys(order).length">
			<div class="flex items-center justify-between pb-4 mb-4 border-b-2">
				<div class="">
					<h2>Forecast Order</h2>
					<h1 class="text-gray-700 text-2xl sm:text-5xl leading-none">
						{{ order.order_details.reference_id }}
					</h1>
					<h4>
						{{ order.order_details.job_name }}
					</h4>
				</div>
				<div class="text-right">
					<action-button class="btn btn-green" @button-clicked="showAudit = !showAudit" v-text="showAudit ? 'hide audit' : 'show audit'"></action-button>
				</div>
			</div>
			<div class="mb-2" v-if="showAudit">
				<span class="font-bold text-black">Forecast Audit</span>
				<div class="flex space-x-2 space-y-2 mt-2">
					<div class="border p-2 rounded" v-for="(details, user) in order.audit">
						<div class="flex items-center justify-between">
							<p class="font-bold">{{ user }}</p>
							<button class="underline text-green-500 hover:no-underline" @click="toggleShowUser(user)" v-text="showUser.includes(user) ? 'hide' : 'show'">details</button>
						</div>
						<div class="divide-y">
							<div class="text-sm py-2" v-for="(items, date) in details">
								{{ date }}
								<div class="px-2 divide-y" v-for="(breakdown, categoryId) in items">
									<p>{{ categoryById(categoryId) }} - {{ breakdown.qty }} items</p>
									<div class="pl-2" v-if="showUser.includes(user)">
										<div v-for="product in breakdown.products">
											{{ product.product }} - {{ product.action }} - {{ product.qty }}
										</div>
									</div>
								</div>
							</div>							
						</div>
					</div>					
				</div>
			</div>
			<div class="grid grid-cols-12 bg-gray-600 text-white px-2 py-1 text-sm">
				<div class="col-span-3">
					product
				</div>
				<div class="col-span-8">
					details
				</div>
				<div class="col-span-1 text-right">
					qty
				</div>
			</div>
			<div class="mb-6" v-for="(products, key) in order.products" v-if="products.length">
				
				<div class="grid grid-cols-12 border-b bg-gray-200 px-2 py-1 text-black text-xs">
					<div class="col-span-3 font-bold">{{ categoryByKey(key) }}</div>
					<div class="col-span-8" v-if="key != 'tools'">
						<div class="flex divide-x overflow-auto">
							<div class="px-1 text-center" v-for="section in sectionNames[key]" :class="[key == 'reticulation' ? 'w-40' : 'w-12']">
								{{ sectionName[key] }} {{ section }}
							</div>
						</div>
					</div>
				</div>
				<div class="grid grid-cols-12 border-b py-1 text-sm px-2" v-for="(product, index) in products">
					<div class="col-span-3 text-black font-bold">
						{{ product.name }}
					</div>
					<div class="col-span-8">
						<div class="flex divide-x overflow-auto" v-if="key != 'tools'">
							<div class="px-1 text-center" v-for="qty in displayProducts[key][index]" :class="[key == 'reticulation' ? 'w-40' : 'w-12']">
								{{ qty }}
							</div>
						</div>
					</div>
					<div class="col-span-1 font-bold text-black text-base text-right">
						{{ product.forecasted_qty }}
					</div>
				</div>
					
			</div>
		</div>
		
	</div>
</template>

<script>
	import {formatDistance, parseISO} from 'date-fns';
export default {
	name: 'JobForecastDetail',
	data () {
		return {
			order: {},
			sectionName: {
				carport: 'Phase',
				common: 'Block',
				final_fix: 'Unit',
				final_fix_gen: 'Phase',
				first_fix: 'Block',
				reticulation: 'Area',
				reticulation_general: 'Phase',
				special_area: 'Area',
				tools: 'Job',
				wire: 'Block',
			},
			displayProducts: {},
			sectionNames: {},
			unitProductBreakDown: [],
			units: {},
			showAudit: false,
			showUser: [],
		}
	},
	methods: {
		daysFrom: function(dateString){
			return formatDistance(parseISO(dateString, 'yyyy-MM-dd HH:mm:ss', new Date()), new Date(), { addSuffix: true });
		},
		categoryByKey: function(key){
			let cat = this.$store.getters.getProductCategoryNameByKey(key);
			return cat ? cat : key.charAt(0).toUpperCase() + key.slice(1);
		},
		categoryById: function(id){
			let cat = this.$store.getters.getProductCategoryNameById(id);
			return cat;
		},
		toggleShowUser: function(user){
			let itemIndex = this.showUser.indexOf(user);
			if(itemIndex == -1){
				this.showUser.push(user);
				return;
			}
			this.showUser.splice(itemIndex,1);
		},
		reload: function () {
			// console.log('here');
			this.$http.get(`jobs/${this.$route.params.id}/forecasts/`)
				.then(response => {
                    // console.log(response.data)
                    let order = {
                    	order_details: response.data.details,
                    	products: response.data.products,
                    	audit: response.data.audit,
                    }
                    this.order = Object.assign({}, this.order, order);
                    if(this.order.products.final_fix.length){
                    	let products = this.$_(this.order.products.final_fix).map(prod => {
                    		return this.$_(prod.forecasts).map(fc => {
                    			fc.product = prod.name,
                    			fc.prodId = prod.id
                    			return fc;
                    		}).value();
                    	}).flatten(true).value();
                    	this.units = this.$_(products).map('section_name').uniq().value();
                    	products = this.$_(products).groupBy(prod => prod.product).value();
                    	this.$_(products).forEach((fcp, name) => {
                    		let set = [];
                    		this.units.forEach(unit => {
                    			let exists = fcp.filter(fc => {
                    				return fc.section_name == unit;
                    			});
                    			let value = exists.length ? exists[0].forecasted_qty : null;
                    			set.push(value);
                    			
                    		});
							this.unitProductBreakDown.push(set);
                    	});
                    	//console.log(products);
                    }
                    Object.keys(this.order.products).forEach((section) => {
                    	let products = this.$_(this.order.products[section]).map(prod => {
                    		return this.$_(prod.forecasts).map(fc => {
                    			fc.product = prod.name,
                    			fc.prodId = prod.id
                    			return fc;
                    		}).value();
                    	}).flatten(true).value();
                    	let uniqueNames = this.$_(products).map('section_name').uniq().value();

                    	this.$set(this.sectionNames, section, uniqueNames);
                    	products = this.$_(products).groupBy(prod => prod.product).value();

                    	this.$set(this.displayProducts, section, []);
                    	this.$_(products).forEach((fcp, name) => {
                    		let set = [];
                    		this.sectionNames[section].forEach(name => {
                    			let exists = fcp.filter(fc => {
                    				return fc.section_name == name;
                    			});
                    			let value = this.$_(exists).sumBy('forecasted_qty') || null;
                    			//let value = exists.length ? exists[0].forecasted_qty : null;
                    			set.push(value);
                    		});
							this.displayProducts[section].push(set);
                    	});
                    })
				})
				.catch(err => {
					this.error = err
				})
		}
	},
	components: {
	},
	created: function () {
		this.$store.commit('setJobName', null)
		// console.log('here11');
		this.reload()
	}
}
</script>
